"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var detect = require('detect-browser').detect;
var qs = require("qs");
var detectedBrowser = detect();
var CareerSiteUrlProvider = (function () {
    function CareerSiteUrlProvider(applicationBase, corp, careerSiteId, lang) {
        this.applicationBase = applicationBase;
        this.corp = corp;
        this.careerSiteId = careerSiteId;
        this.lang = lang;
    }
    CareerSiteUrlProvider.prototype.getLoginUrl = function (returnURL) {
        var encodedLang = encodeURIComponent("&lang=" + this.lang);
        return this.applicationBase + "ats/careersite/login.aspx?c=" + this.corp + "&site=" + this.careerSiteId + "&lang=" + this.lang + "&returnurl=" + returnURL + encodedLang;
    };
    CareerSiteUrlProvider.prototype.getMobileFriendlyJobDetailUrl = function (requistionID, searchUrl) {
        if (searchUrl === void 0) { searchUrl = ''; }
        if (searchUrl) {
            if (new URLSearchParams(searchUrl).get('c')) {
                return "~/ux/ats/careersite/" + this.careerSiteId + "/home/requisition/" + requistionID + searchUrl;
            }
            return "~/ux/ats/careersite/" + this.careerSiteId + "/home/requisition/" + requistionID + searchUrl + "&c=" + this.corp;
        }
        else {
            return "~/ux/ats/careersite/" + this.careerSiteId + "/home/requisition/" + requistionID + "?c=" + this.corp;
        }
    };
    CareerSiteUrlProvider.prototype.getRoutePrefix = function () {
        return this.applicationBase + "ux/ats/careersite/" + this.careerSiteId + "/home";
    };
    CareerSiteUrlProvider.prototype.getPrefix = function () {
        return "/ux/ats/careersite/" + this.careerSiteId + "/home";
    };
    CareerSiteUrlProvider.prototype.getSearchURL = function () {
        var shouldUseHashRouter = window.location.hash.length > 0;
        return shouldUseHashRouter ? "/" : "" + this.getRoutePrefix() + window.location.search;
    };
    CareerSiteUrlProvider.prototype.setLanguageAsQueryStringParameter = function (url, cultureName, browser) {
        if (browser === void 0) { browser = detectedBrowser; }
        if (browser.name === 'ie') {
            var actual = url.substring(0, url.indexOf('?'));
            var queryString = url.substring(url.indexOf('?') + 1);
            var queryParams = queryString.split('&').reduce(function (q, query) {
                var chunks = query.split('=');
                return (q[chunks[0]] = chunks[1], q);
            }, {});
            queryParams['lang'] = cultureName;
            return actual + "?" + qs.stringify(queryParams, { encode: false });
        }
        else {
            var tempUrl = new URL(url);
            var params = new URLSearchParams(tempUrl.search);
            params.set("lang", cultureName);
            tempUrl.search = params.toString();
            return tempUrl.href;
        }
    };
    return CareerSiteUrlProvider;
}());
exports.CareerSiteUrlProvider = CareerSiteUrlProvider;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/CareerSiteUrlProvider.ts
// module id = 69
// module chunks = 0